import { render, staticRenderFns } from "./AllocationOrgans.vue?vue&type=template&id=b3f86d2a"
import script from "./AllocationOrgans.vue?vue&type=script&lang=js"
export * from "./AllocationOrgans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports